import type { IMosaicTocExpanded } from "./interface";

/**
 * Clears the temporary block after a patch response has been handled.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with no active patch block.
 */
export const toc_updateAfterPatch = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  blocked: false,
});
